import { jsx as _jsx } from "react/jsx-runtime";
/**
 * クリップボードコピーボタンコンポーネント
 *
 * テキストをクリップボードにコピーする汎用ボタン。
 * コピー成功時に2秒間フィードバックを表示。
 * className でスタイルをカスタマイズ可能。
 */
import { Check, Copy } from 'lucide-react';
import { useCopyToClipboard } from '../hooks/use-copy-to-clipboard';
import { cn } from '../utils';
export function CopyButton({ content, className, 'aria-label': ariaLabel }) {
    const { copied, copy } = useCopyToClipboard();
    return (_jsx("button", { type: "button", onClick: () => copy(content), className: cn('inline-flex h-6 w-6 items-center justify-center rounded transition-colors', className), "aria-label": ariaLabel ?? 'コピー', children: copied ? (_jsx(Check, { className: "h-3.5 w-3.5 text-green-500", "data-testid": "copy-success" })) : (_jsx(Copy, { className: "h-3.5 w-3.5", "data-testid": "copy-idle" })) }));
}
//# sourceMappingURL=CopyButton.js.map